import { buildModelManager } from "../builder.js";
const DefaultEvalSystemSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  createdById: true,
  description: { markdown: true, truncatedHTML: true },
  evaluationPrompt: { markdown: true, truncatedHTML: true },
  evaluationSchema: true,
  extractedFields: true,
  fieldRules: true,
  globalRubric: { markdown: true, truncatedHTML: true },
  ingestionConfig: true,
  knowledgeBaseConfig: true,
  metadata: true,
  name: true,
  refinementHistory: true,
  status: true,
  templateDocument: { url: true, mimeType: true, fileName: true },
  updatedAt: true
};
const modelApiIdentifier = "evalSystem";
const pluralModelApiIdentifier = "evalSystems";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEvalSystemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEvalSystemSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEvalSystemSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEvalSystemSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEvalSystemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEvalSystemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEvalSystemSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createEvalSystem",
    operationReturnType: "CreateEvalSystem",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { evalSystem: { required: false, type: "CreateEvalSystemInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEvalSystemSelection
  },
  {
    type: "action",
    operationName: "bulkCreateEvalSystems",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateEvalSystemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEvalSystemSelection
  },
  {
    type: "action",
    operationName: "updateEvalSystem",
    operationReturnType: "UpdateEvalSystem",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      evalSystem: { required: false, type: "UpdateEvalSystemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEvalSystemSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateEvalSystems",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateEvalSystemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEvalSystemSelection
  },
  {
    type: "action",
    operationName: "deleteEvalSystem",
    operationReturnType: "DeleteEvalSystem",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteEvalSystems",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertEvalSystem",
    operationReturnType: "UpsertEvalSystem",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      evalSystem: { required: false, type: "UpsertEvalSystemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateEvalSystemResult": { hasReturnType: false },
      "... on UpdateEvalSystemResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEvalSystemSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertEvalSystems",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertEvalSystemsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultEvalSystemSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "evalSystemGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const EvalSystemManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultEvalSystemSelection,
  operations
);
export {
  DefaultEvalSystemSelection,
  EvalSystemManager
};
//# sourceMappingURL=EvalSystem.js.map
